import { render, staticRenderFns } from "./edit-category-modal.vue?vue&type=template&id=9f335164&scoped=true"
import script from "./edit-category-modal.vue?vue&type=script&lang=js"
export * from "./edit-category-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f335164",
  null
  
)

export default component.exports